import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import * as Styles from './SegmentStep.styles';
import { Button, IconArrow, TextField } from 'gatorcomponents';

const SegmentStep = ({
  segmentStepLocales, continueButtonClick, segmentInputValue, setSegmentInputValue, mobile, iconMaia,
}) => {
  const [displayAutoComplete, setDisplayAutoComplete] = useState(false);
  const [autoCompleteList, setAutoCompleteList] = useState(segmentStepLocales.optionsList || []);

  const textFieldWrapperRef = useRef(null);


  const handleSetSegmentInputValue = (value) => {
    setSegmentInputValue(value);
  };

  const handleSelectAutoCompleteOption = (value) => {
    handleSetSegmentInputValue(value);
    setDisplayAutoComplete(false);
  };

  const filterAutoCompleteList = useCallback((inputValue) => {
    if (!inputValue) {
      setAutoCompleteList(segmentStepLocales.optionsList || []);
      return;
    }
    const filteredList = (segmentStepLocales.optionsList || []).filter(item => item.label.toLowerCase().includes(inputValue.toLowerCase()));
    setAutoCompleteList(filteredList);
  }, [segmentStepLocales]);

  useEffect(() => {
    filterAutoCompleteList(segmentInputValue);
  }, [segmentInputValue, filterAutoCompleteList]);

  const onChangeInput = (e) => {
    handleSetSegmentInputValue(e.target.value);
  };

  const handleContinueButtonClick = () => {
    continueButtonClick && continueButtonClick();
  };

  const handleCloseAutoCompleteOnBlur = useCallback(() => {
    function handleClickOutside(event) {
      if (textFieldWrapperRef.current && !textFieldWrapperRef.current.contains(event.target)) {
        setDisplayAutoComplete(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    handleCloseAutoCompleteOnBlur();
  }, [handleCloseAutoCompleteOnBlur]);

  return (
    <Styles.Wrapper data-testid="ai-builder-create-site-segment-step">
      <Styles.Title>
        <Styles.IconMaia src={iconMaia} />
        {segmentStepLocales.title}
      </Styles.Title>

      <Styles.InputHeadText>{segmentStepLocales.inputHeadText}</Styles.InputHeadText>

      <Styles.TextFieldWrapper ref={textFieldWrapperRef}>
        <TextField
          testId="segment-step-input-field"
          leadingIcon={!mobile && 'IconSearch'}
          label={segmentStepLocales.inputPlaceholder}
          onChange={onChangeInput}
          value={segmentInputValue}
          onFocusInput={() => setDisplayAutoComplete(true)}
          autoComplete="off"
          maxLength={60}
        />

        {displayAutoComplete && (
          <Styles.AutoComplete>
            {autoCompleteList.map(item => (
              <Styles.AutoCompleteItem
                key={item.value}
                isSelected={segmentInputValue === item.label}
                onClick={() => handleSelectAutoCompleteOption(item.label)}
                role="button"
              >
                {item.label}
              </Styles.AutoCompleteItem>
            ))}
          </Styles.AutoComplete>
        )}
      </Styles.TextFieldWrapper>

      <Styles.ButtonWrapper>
        <Button
          testId="segment-step-continue-button"
          label={segmentStepLocales.buttonLabel}
          width={mobile ? 'full' : 'fit'}
          size="large"
          onClick={handleContinueButtonClick}
          disabled={!segmentInputValue}
          iconRight={
            <IconArrow direction="right" />
          }
        />
      </Styles.ButtonWrapper>
    </Styles.Wrapper>
  );
};

export default SegmentStep;
